import { useAppSelector } from './useAppStore';
import { selectCurrentUser, selectIsAuthenticated, selectAuthStatus, selectAuthInitialized } from '../store/slices/authSlice';

export function useAuth() {
  const user = useAppSelector(selectCurrentUser);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const status = useAppSelector(selectAuthStatus);
  const initialized = useAppSelector(selectAuthInitialized);

  return { user, isAuthenticated, status, initialized, isLoading: status === 'loading' };
}
